<h1 mat-dialog-title class="fw-bolder fs-5">Sync Data From MDMS</h1>
<mat-icon class="close-dialog-icon" mat-dialog-close=""> close</mat-icon>
<mat-dialog-content class="mat-typography">
    <!-- Fullscreen Loader Overlay -->
    <div *ngIf="showLoader"
        class="loader-overlay d-flex flex-column justify-content-center align-items-center text-center"
        style="position: relative; padding-top: 40px;">

        <!-- Fixed Progress Bar -->
        <mat-progress-bar mode="indeterminate" class="w-100 custom-progress-bar"
            style="position: absolute; top: 0; left: 0; margin-top: 1vh;">
        </mat-progress-bar>

        <!-- Spinner -->
        <mat-progress-spinner diameter="40" mode="indeterminate" color="primary" class="mt-4">
        </mat-progress-spinner>

        <div class="mt-4 loader-message w-100" style="max-width:80vh; text-align: left;">
            <ng-container *ngFor="let message of loaderMessages; let i = index">
                <p class="d-flex align-items-center gap-2 mb-3" style="width: 100%; margin: 0;">
                    <span>
                        {{ message }}
                        <span *ngIf="i === loaderMessages.length - 1 && !allDone" class="dots"></span>
                        <img src="./../../../../assets/images/icons/tick.svg"
                            *ngIf="i < loaderMessages.length - 1 || allDone" style="margin-left: 6px;">
                    </span>
                </p>
            </ng-container>
        </div>
    </div>


    <div class="d-flex flex-column align-items-center justify-content-center overlay" *ngIf="!loaded && !showLoader">
        <div class="loader mt-3"></div>
        <div class="mt-3 text-center" *ngIf="download">
            This process may take a few minutes. Please do not close or refresh the page.
        </div>
    </div>


    <div *ngIf="loaded && !showLoader">
        <div class="row">
            <!-- Download Template Button -->
            <div class="col-6 mb-2">
                <button class="btn d-flex w-100 flex-column align-items-center mdmsBtn"
                    (click)="getStaticPresignedURL()" (mouseover)="isHoveredDownload = true;"
                    (mouseleave)="isHoveredDownload = false;">
                    <mat-icon class="icon custom-icon"
                        [svgIcon]="!isHoveredDownload ? 'mdms_load' : 'mdms_load_selected'"></mat-icon>
                    <span>Download Template</span>
                </button>
            </div>

            <!-- Upload Updated Template Button -->
            <div class="col-6 mb-2">
                <button class="btn d-flex w-100 flex-column align-items-center mdmsBtn" (click)="fileUpload.click()"
                    (mouseover)="isHoveredUpload = true;" (mouseleave)="isHoveredUpload = false;">
                    <mat-icon class="icon custom-icon"
                        [svgIcon]="!isHoveredUpload ? 'mdms_upload' : 'mdms_upload_selected'"></mat-icon>
                    <span>Upload Updated Data</span>
                </button>
                <!-- Hidden file input -->
                <input type="file" class="file-input" accept=".xlsx, .xlsb, .xlsm" (change)="onFileSelected($event)"
                    #fileUpload style="display: none;">
            </div>

        </div>
        <div class="mt-4">
            <!-- Display selected file name if a file is selected -->
            <p *ngIf="fileSelected"><strong>Selected File: </strong><span class="blue-text">{{
                    fileName }}</span></p>
            <!-- Error messages -->
            <mat-error *ngIf="fileNotAvailable">File is required.</mat-error>
            <mat-error *ngIf="invalidFileName">Invalid filename. Please use exactly one dot in
                the
                filename.</mat-error>
            <mat-error *ngIf="invalidFileType">Invalid file type, only Excel file types are
                allowed.</mat-error>
            <mat-error *ngIf="invalidFileSize">File size exceeds the maximum limit of 100
                MB.</mat-error>
            <p><strong> Latest Version: </strong> <span class="blue-text">{{ latestVersion }}</span></p>
            <p><strong> Last Updated By: </strong> <span class="blue-text">{{ lastUpdatedBy }}</span></p>
            <p><strong> Last Updated On: </strong> <span class="blue-text">{{ lastUpdatedOn }}</span></p>

            <div class="d-flex justify-content-between align-items-start pt-3">
                <!-- Left side: Stacked text -->
                <div>
                    <p class="mb-2 blue-text">Use the 'Download Template' button to download the template for system
                        setup.</p>
                    <p class="mb-0 blue-text">Click on 'Upload Updated Data' to upload an updated file.</p>
                </div>
            </div>
            <mat-dialog-actions align="end" class="me-6 mb-1 d-flex" [ngClass]="{'disabled': !saveFlag}">
                <button mat-flat-button mat-dialog-close class="buttonSecondary me-2">
                    Cancel
                </button>
                <button mat-flat-button color="primary" class="buttonAdd" (click)="addMdms()"
                    [ngClass]="{'disabled': !fileFlag}">
                    {{actionBtn}}
                </button>
            </mat-dialog-actions>
        </div>

    </div>
</mat-dialog-content>